import React, { useEffect } from 'react';
import { Form, Spin } from 'antd';
import { FormProps } from 'antd/es/form';
import { Store } from 'rc-field-form/es/interface';
import { AxiosRequestConfig, AxiosResponse, Method } from 'axios';
import useFormSubmit from 'App/lib/Form/useFormSubmit';

export interface SimpleFormProps extends FormProps {
  url: string;
  method?: Method;
  axiosConfig?: AxiosRequestConfig;
  beforeSubmit?: (data: Store) => Store;
  onSuccess?: (response: AxiosResponse, data: Store) => void;
  onFailure?: (response: AxiosResponse, data: Store) => void;
  onWorking?: (loading: boolean) => void;
  spinner?: boolean;
}

const SimpleForm: React.FC<SimpleFormProps> = ({
  url,
  method = 'post',
  axiosConfig = {},
  beforeSubmit = (data) => data,
  onSuccess = () => {},
  onFailure = () => {},
  onWorking = () => {},
  form: propForm,
  spinner = true,
  children,
  ...props
}) => {
  const [form] = Form.useForm(propForm);
  const { isSubmitting, onSubmit } = useFormSubmit({
    url,
    method,
    form,
    axiosConfig,
    onSuccess,
    onFailure,
    beforeSubmit,
  });

  useEffect(() => {
    onWorking(isSubmitting);
  }, [isSubmitting]);

  return (
    <Spin spinning={spinner && isSubmitting}>
      <Form layout="vertical" {...props} form={form} onFinish={onSubmit}>
        {children}
      </Form>
    </Spin>
  );
};

export default SimpleForm;
